var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-select',{class:{ 'inline-picker': _vm.small },attrs:{"options":_vm.options},model:{value:(_vm.selectedRate),callback:function ($$v) {_vm.selectedRate=$$v},expression:"selectedRate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }